/**
 * @fileoverview GET handler for the "/integrations/currents_integrations_config" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsCurrentsIntegrationsConfig } from "./constants";
import type { IntegrationsCurrentsIntegrationsConfigResult } from "./types";
import { isIntegrationsCurrentsIntegrationsConfigResult } from "./validators";

export const getIntegrationsCurrentsIntegrationsConfig = reactQueryFetcherAdapter(
  integrationsCurrentsIntegrationsConfig,
  (signal: AbortSignal): Promise<IntegrationsCurrentsIntegrationsConfigResult> => {
    return fetch("/integrations/currents_integrations_config", "GET", {}, { signal });
  },
  isIntegrationsCurrentsIntegrationsConfigResult
);
